
/* styles */
require("!!vue-style-loader!css-loader!../node_modules/vue-loader/lib/style-rewriter?id=data-v-6aa96c5f!sass-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProjectInfo.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./ProjectInfo.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-6aa96c5f!../node_modules/vue-loader/lib/selector?type=template&index=0!./ProjectInfo.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./project_info/ProjectInfo.vue
// module id = 4
// module chunks = 0